<template>
    <MainContainer>
        <template v-slot:sidebar>
            <h5>Weitere Funktionen</h5>
            <!--<b-button variant="outline-primary" block>SingPause</b-button>-->
            <b-button
                v-if="isSinger"
                variant="outline-primary"
                block
                @click="openAnwesenheitsstatistik"
                >Anwesenheitsstatistik</b-button
            >
            <b-button
                v-if="isGuestSinger"
                variant="outline-primary"
                block
                @click="openProbenbenefit"
                >Probenvergütung</b-button
            >
            <b-button
                v-if="isSingPauseMitglied || isSingPauseSchule"
                variant="outline-primary"
                block
                @click="openSingPause"
                >SingPause</b-button
            >
        </template>
        <div class="mv-mitglieder">
            <MitgliederDetail :id="id" @update="update" />
        </div>
        <b-modal
            v-if="isSinger"
            id="mitgliederAnwesenheit"
            ref="mitgliederAnwesenheit"
            :title="title"
            size="xl"
            ok-title="OK"
            scrollable
            ok-only
        >
            <MitgliederAnwesenheit :id="id" />
        </b-modal>
        <MitgliederProbenbenefitModal v-if="isGuestSinger" :id="id" />
        <SingPauseMitgliederModal v-if="isSingPauseMitglied" :id="id" />
        <SingPauseSchulenModal v-if="isSingPauseSchule" :id="id" />
    </MainContainer>
</template>

<script>
// @ is an alias to /src
import { ApiFactory } from "@/api/ApiFactory.js";
import MainContainer from "@/components/MainContainer/MainContainer";
import MitgliederDetail from "@/components/MitgliederDetail/MitgliederDetail";
import MitgliederAnwesenheit from "@/components/MitgliederAnwesenheit/MitgliederAnwesenheit";
import MitgliederProbenbenefitModal from "@/components/MitgliederProbenbenefit/MitgliederProbenbenefitModal";
import SingPauseMitgliederModal from "@/components/SingPauseMitglieder/SingPauseMitgliederModal";
import SingPauseSchulenModal from "@/components/SingPauseSchulen/SingPauseSchulenModal";

const MitgliederApi = ApiFactory.get("mitglieder");

export default {
    name: "mitglieder-detail",
    components: {
        MainContainer,
        MitgliederDetail,
        MitgliederAnwesenheit,
        MitgliederProbenbenefitModal,
        SingPauseMitgliederModal,
        SingPauseSchulenModal
    },
    data() {
        return {
            name: "",
            isSinger: false,
            isGuestSinger: false,
            isSingPauseMitglied: false,
            isSingPauseSchule: false
        };
    },
    computed: {
        id() {
            return this.$route.params.id;
        },
        title() {
            var title = "Anwesenheitsstatisik";
            if (this.name) {
                title += ": " + this.name;
            }
            return title;
        }
    },
    created() {
        this.fetchMitgliedData();
    },
    watch: {
        id: {
            handler() {
                this.fetchMitgliedData();
            }
        }
    },
    methods: {
        async fetchMitgliedData() {
            const response = await MitgliederApi.getSingle(this.id, {
                fields: ["name", "vorname", "status_singer", "singpause"]
            });
            if (response.ok) {
                this.name = response.json.vorname + " " + response.json.name;
                this.isSinger = true; // response.json.singer == 1;
                this.isGuestSinger = response.json.guest_singer == 1;
                this.isSingPauseMitglied = response.json.sp_mitglied == 1;
                this.isSingPauseSchule = response.json.sp_schulen == 1;
            }
        },
        openAnwesenheitsstatistik() {
            this.$root.$emit("bv::show::modal", "mitgliederAnwesenheit");
        },
        openProbenbenefit() {
            this.$root.$emit("bv::show::modal", "mitgliederProbenbenefit");
        },
        openSingPause() {
            if (this.isSingPauseSchule) {
                this.$root.$emit("bv::show::modal", "singpauseSchulen");
            } else {
                this.$root.$emit("bv::show::modal", "singpauseMitglieder");
            }
        },
        update() {
            this.fetchMitgliedData();
        }
    }
};
</script>
